// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".e2ef14869e8c70a579026f27d096c63dc13910ec.chunk.bundle.js";
};